"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalHeader = void 0;
var _ModalHeader = require("./ModalHeader.styles");
var _Icon = require("../../../../UI/Icon");
var _jsxRuntime = require("react/jsx-runtime");
const ModalHeader = props => {
  const {
    children,
    message,
    messageIcon,
    title,
    subTitle
  } = props;
  const styles = (0, _ModalHeader.useStyles)(props);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("header", {
    className: styles['cc-ModalHeader'],
    children: [message && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: styles['cc-ModalHeader__message'],
      children: [messageIcon && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: styles['cc-ModalHeader__message__icon'],
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
          name: messageIcon,
          width: 12,
          height: 12,
          fillColor: "#fff"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: styles['cc-ModalHeader__message__text'],
        children: message
      })]
    }), title && /*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
      className: styles['cc-ModalHeader__title'],
      children: title
    }), subTitle && /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
      className: styles['cc-ModalHeader__sub-title'],
      children: subTitle
    }), children]
  });
};
exports.ModalHeader = ModalHeader;